import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import { btnHideFalse, closeShowTitle, openShowTitle,closeFileMenu, setSaveFilePath, setSavePythonPath } from '../reducers/menus.js'
import ScratchBlocks from 'scratch-blocks';

import analytics from '../lib/analytics';
import log from '../lib/log';
import {
    LoadingStates,
    getIsLoadingUpload,
    onLoadedProject,
    requestProjectUpload
} from '../reducers/project-state';

import {
    tabsActive
} from '../reducers/editor-tab';

import {
    openLoadingProject,
    closeLoadingProject
} from '../reducers/modals';
import {
    setCodeValue
} from '../reducers/monacode.js';

/**
 * SBFileUploader component passes a file input, load handler and props to its child.
 * It expects this child to be a function with the signature
 *     function (renderFileInput, loadProject) {}
 * The component can then be used to attach project loading functionality
 * to any other component:
 *
 * <SBFileUploader>{(renderFileInput, loadProject) => (
 *     <MyCoolComponent
 *         onClick={loadProject}
 *     >
 *         {renderFileInput()}
 *     </MyCoolComponent>
 * )}</SBFileUploader>
 */

const messages = defineMessages({
    loadError: {
        id: 'gui.projectLoader.loadError',
        defaultMessage: 'The project file that was selected failed to load.',
        description: 'An error that displays when a local project file fails to load.'
    }
});

class SBFileUploader extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'getProjectTitleFromFilename',
            'renderFileInput',
            'setFileInput',
            'handleChange',
            'handleClick',
            'onload',
            'resetFileInput',
            'handlecenterOnBlock'
        ]);
    }
    componentWillMount() {
        this.reader = new FileReader();
        this.reader.onload = this.onload;
        this.resetFileInput();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isLoadingUpload && !prevProps.isLoadingUpload && this.fileToUpload && this.reader) {
            this.reader.readAsArrayBuffer(this.fileToUpload);
        }
    }
    componentWillUnmount() {
        // 上传文件时，操作上以双击选中文件方式上传会出现有时上传的数据为null，初步判断为这里先执行了，导致赋值为null（待进一步测试）
        // this.reader = null;
        // this.resetFileInput();
    }
    resetFileInput() {
        this.fileToUpload = null;
        if (this.fileInput) {
            this.fileInput.value = null;
        }
    }
    getProjectTitleFromFilename(fileInputFilename) {
        if (!fileInputFilename) return '';
        // only parse title with valid scratch project extensions
        // (.sb, .sb2, and .sb3)
        const matches = fileInputFilename.match(/^(.*)\.sb[23]?$/);
        if (!matches) return '';
        return matches[1].substring(0, 100); // truncate project title to max 100 chars
    }
    // called when user has finished selecting a file to upload
    handleChange(e) {
        const thisFileInput = e.target;
        if (thisFileInput.files) { // Don't attempt to load if no file was selected
            this.fileToUpload = thisFileInput.files[0];
            this.filePath = this.fileToUpload.path
            this.props.requestProjectUpload(this.props.loadingState);
        }
    }
    // called when file upload raw data is available in the reader
    onload() {
        if (this.reader) {
            this.props.onLoadingStarted();
            this.props.btnTrue()
            var code = document.getElementById('codeSmallBtn')
            code.style.display = 'block';
            const filename = this.fileToUpload && this.fileToUpload.name;
            // this.reader.result = this.dataURLtoBlob(this.reader.result);
            const ext = filename.split('.')[1]

            if (ext == 'py') {
                let buffers = new FileReader()
                buffers.onload = (e) => {
                    this.props.setSavePythonPath(this.filePath)
                    if (filename) {
                        const uploadedProjectTitle = filename.split('.')[0]
                        this.props.onUpdateProjectTitle(uploadedProjectTitle); // 网页端赋值文件名到input
                    }
                    this.props.setSwitchWorked(true)
                    this.props.setMonaCodeValue(e.target.result)
                }
                buffers.readAsText(new Blob([this.reader.result]))

                this.props.onLoadingFinished(this.props.loadingState, false);
                this.resetFileInput();
                return
            }

            this.props.vm.loadProject(this.reader.result)
                .then(() => {
                    analytics.event({
                        category: 'project',
                        action: 'Import Project File',
                        nonInteraction: true
                    });
                    this.props.setSaveFilePath(this.filePath)
                    if (filename) {
                        const uploadedProjectTitle = this.getProjectTitleFromFilename(filename);
                        this.props.onUpdateProjectTitle(uploadedProjectTitle); // 网页端赋值文件名到input
                        document.getElementsByClassName('menu-bar_title-field-growable_2DAmE')[0].value = uploadedProjectTitle; // 桌面应用端赋值文件名到input
                    }

                    // Remove the hash if any (without triggering a hash change event or a reload)
                    history.replaceState({}, document.title, '.');
                    this.props.onLoadingFinished(this.props.loadingState, true);
                    // Reset the file input after project is loaded
                    // This is necessary in case the user wants to reload a project

                    this.props.setSwitchWorked(false)
                    this.resetFileInput();
                    this.handlecenterOnBlock()
                })
                .catch(error => {
                    log.warn(error);
                    // alert(this.props.intl.formatMessage(messages.loadError)); // eslint-disable-line no-alert 项目加载失败弹窗
                    this.props.onLoadingFinished(this.props.loadingState, false);
                    // Reset the file input after project is loaded
                    // This is necessary in case the user wants to reload a project
                    this.resetFileInput();
                });
        }
    }
    // 默认定位到某个块
    handlecenterOnBlock() {
        let TopBlocks = window.workspace.getTopBlocks(true)
        if (TopBlocks.length !== 0) {

            window.workspace.centerOnBlock(TopBlocks[0].id)
        } else {

            window.workspace.getAllBlocks()[0] && window.workspace.centerOnBlock(window.workspace.getAllBlocks()[0].id)
        }
    }
    handleClick() {
        // open filesystem browsing window
        this.fileInput.click();
    }
    setFileInput(input) {
        this.fileInput = input;

        // 判断文件上传时，默认显示第一个机器人
        // const robots = this.props.vm.runtime.targets.filter(target => target.isRobot || target.isStage);
        // if (robots[1]){

        //     this.props.vm.setEditingTarget(robots[1].id);
        //     this.props.vm.setDefaultOptions(robots[1]);
        // } else {
        //     this.props.vm.setEditingTarget(robots[0].id);
        //     this.props.vm.setDefaultOptions(robots[0]);
        // }


    }
    renderFileInput() {
        return (
            <input
                accept=".sb3,.sb2,.sb,.py"
                ref={this.setFileInput}
                style={{ display: 'none' }}
                type="file"
                onChange={this.handleChange}
            />
        );
    }
    render() {
        return this.props.children(this.props.className, this.renderFileInput, this.handleClick);
    }
}

SBFileUploader.propTypes = {
    canSave: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
    children: PropTypes.func,
    className: PropTypes.string,
    intl: intlShape.isRequired,
    isLoadingUpload: PropTypes.bool,
    loadingState: PropTypes.oneOf(LoadingStates),
    onLoadingFinished: PropTypes.func,
    onLoadingStarted: PropTypes.func,
    onUpdateProjectTitle: PropTypes.func,
    requestProjectUpload: PropTypes.func,
    vm: PropTypes.shape({
        loadProject: PropTypes.func
    })
};
SBFileUploader.defaultProps = {
    className: ''
};
const mapStateToProps = state => {
    const loadingState = state.scratchGui.projectState.loadingState;
    return {
        isLoadingUpload: getIsLoadingUpload(loadingState),
        loadingState: loadingState,
        vm: state.scratchGui.vm,
        showtitle: state.scratchGui.menus.showtitle
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onLoadingFinished: (loadingState, success) => {
        dispatch(onLoadedProject(loadingState, ownProps.canSave, success));
        dispatch(closeLoadingProject());
        dispatch(closeFileMenu());
    },
    requestProjectUpload: loadingState => dispatch(requestProjectUpload(loadingState)),
    onLoadingStarted: () => {
        dispatch(tabsActive(0))
        dispatch(openLoadingProject())
    },
    btnTrue: () => {
        dispatch(btnHideFalse())
    },
    setSwitchWorked: (status = false) => {
        if (status) {
            dispatch(closeShowTitle())
        } else {
            dispatch(openShowTitle())
        }
    },
    setMonaCodeValue: (code) => {
        dispatch(setCodeValue(code));
        dispatch(closeFileMenu());
    },
    setSaveFilePath: (path)=>{
        dispatch(setSaveFilePath(path))
    },
    setSavePythonPath: (path)=>{
        dispatch(setSavePythonPath(path))
    }
});

// Allow incoming props to override redux-provided props. Used to mock in tests.
const mergeProps = (stateProps, dispatchProps, ownProps) => Object.assign(
    {}, stateProps, dispatchProps, ownProps
);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(injectIntl(SBFileUploader));
